import Vue from 'vue';
import Component from 'vue-class-component';
import { Icon } from '../icon/icon';

require('../../../../icons/checkcircleo.svg');
require('../../../../icons/infocircleo.svg');
require('../../../../icons/exclamationcircleo.svg');
require('../../../../icons/closecircleo.svg');
require('../../../../icons/loading.svg');
require('../../../../icons/close.svg');
require('../../../../icons/copy.svg');

let messageListInstance: Array<Message>;
let messageCount: number;

function getMessageList(): Array<Message> {
  if (!messageListInstance) {
    messageListInstance = []
    const div = document.createElement('div');
    div.innerHTML = `<wc-message></wc-message>`;
    document.body.appendChild(div);

    const messageList = new Vue({
      el: div
    });

    messageCount = 0;
  }

  return messageListInstance;
}

@Component({
  template: require('./message.html'),
  name: 'wc-message',
  components: {
    'wc-icon': Icon 
  }
})
export class MessageList extends Vue {
  messageList: Array<Message> = getMessageList();

  onMessageClose(id: number) {
    Message.remove(id);
  }

  onMessageCopy(message: string) {
    let tempInput = document.createElement('input') as HTMLInputElement;
    document.body.appendChild(tempInput);
    tempInput.value = message;
    tempInput.select();

    try {  
      if (document.execCommand('copy')) {
        Message.success('Copied error', 1.0);
      } else {
        Message.info('Copy failed');
      }
    } catch(err) {  
      Message.info('Copy failed');
    }
    
    document.body.removeChild(tempInput);
  }
}

export type NoticeType = 'info' | 'success' | 'error' | 'warning' | 'loading';

export class Message {
  iconType: string;
  noticeType: NoticeType;
  loading: boolean;

  constructor(private id: number, private content: string, private type: NoticeType, private duration: number = 2.0) {
    this.iconType = ({
      info: 'infocircleo',
      success: 'checkcircleo',
      error: 'closecircleo',
      warning: 'exclamationcircleo',
      loading: 'loading',
    })[type];

    this.noticeType = type;
    if (type === 'loading') this.loading = true;
  }


  static success(content: string, duration: number = 2.0) : number {
    return this.addMessage(content, 'success', duration);
  }
  
  static info(content: string, duration: number = 2.0) : number {
    return this.addMessage(content, 'info', duration);
  }

  static warning(content: string, duration: number = 2.0) : number {
    return this.addMessage(content, 'warning', duration);
  }

  static error(content: string, duration: number = 0.0) : number {
    return this.addMessage(content, 'error', duration);
  }

  static loading(content: string, duration: number = 2.0) : number {
    return this.addMessage(content, 'loading', duration);
  }

  static remove(id: number) {
    let messageList = getMessageList();
    messageList.splice(Message.messageIndex(messageList, id), 1);
  }

  private static addMessage(content: string, type: NoticeType, duration?: number) : number {
    let messageList = getMessageList();
    let message = new Message(messageCount++, content, type, duration)
    messageList.push(message);

    if (duration) {
      window.setTimeout( () => {
        messageList.splice(Message.messageIndex(messageList, message.id), 1);
      }, duration * 1000);
    }

    return message.id;
  }
  

  private static messageIndex(messageList: Message[], id: number) : number  {
    let index = -1;
    for (let i = 0; i < messageList.length; i++) {
      if (messageList[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }
}

// Register global component
Vue.component('wc-message', MessageList);



// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/message/message.ts